(function () {
  function shouldRedirect(formEl) {
    return formEl && formEl.closest('product-form[data-ebook-checkout-redirect="true"]');
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    if (!shouldRedirect(form)) return;

    // Espera um instante para o tema concluir o add-to-cart via AJAX,
    // depois envia para checkout.
    setTimeout(function () {
      window.location.assign('/cart');
    }, 700);
  }, true);
})();
